import React from 'react';
import {connect} from 'react-redux';
import Dimensions from 'react-dimensions';
import {Button, Card} from 'semantic-ui-react';
import {Step, Stepper, StepLabel, StepContent} from 'material-ui/Stepper';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import Tab from '../../components/tab';
import Loading from '../../components/loading';
import GA from '../../helpers/ga';
import config from '../../config';
import {sendPayment, getPaymentPlans} from './actions';
import {getShopifyAppConnection} from '../dashboard-emails-page/actions';

const DEFAULT_STATE = {
	finished: false,
	stepIndex: 0,

	button3MonthsLoading: false,
	button6MonthsLoading: false,
	button12MonthsLoading: false
};

export class EmailPlusSetupPage extends React.Component {
	constructor(props) {
		super(props);
		props.getShopifyAppConnection();

		this.state = {
			...DEFAULT_STATE
		};
	}

	componentDidMount() {
		GA.sendPageView('/dashboard/email-plus');
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.confirmationUrl && nextProps.confirmationUrl !== '' ) {
			window.location.replace(nextProps.confirmationUrl);
		}
	}

	onClickPlan = (chosenPlan, e) => {
		GA.sendEvent('/dashboard/email-plus', 'click', 'select_plan_' + chosenPlan, 1);
		if (this.props.appConnection) {
			switch(chosenPlan) {
				case '3_months_email_plus':
					this.setState({button3MonthsLoading: true});
					break;
				case '6_months_email_plus':
					this.setState({button6MonthsLoading: true});
					break;
				case '12_months_email_plus':
					this.setState({button12MonthsLoading: true});
					break;
				default:
					break;
			}

			this.props.sendPayment(this.props.appConnection, chosenPlan, config.callback_url.payment.email_plus);
		}
	}

	handleNext = () => {
		const {stepIndex} = this.state;
		this.setState({
			stepIndex: stepIndex + 1,
			finished: stepIndex >= 3
		});
	};

	handlePrev = () => {
		const {stepIndex} = this.state;
		if (stepIndex > 0) {
			this.setState({stepIndex: stepIndex - 1});
		}
	};

	renderStepActions(step) {
		const {stepIndex} = this.state;

		return (
			<div style={{margin: '12px 0'}}>
				<RaisedButton
					label={stepIndex === 3 ? 'Finish' : 'Next'}
					disableTouchRipple={true}
					disableFocusRipple={true}
					primary={true}
					onClick={this.handleNext}
					style={{marginRight: 12}}
				/>
				{step > 0 && (
					<FlatButton
						label="Back"
						disabled={stepIndex === 0}
						disableTouchRipple={true}
						disableFocusRipple={true}
						onClick={this.handlePrev}
					/>
				)}
			</div>
		);
	}

	render () {
		if (!this.props.appConnection) {
			return <Loading />;
		}

		let {stepIndex,button3MonthsLoading,button6MonthsLoading,button12MonthsLoading} = this.state;

		if (this.props.paid) {
			stepIndex = 3;
		}

		const paneHeight = this.props.containerHeight - 70;

		return (
			<Tab.Pane
				containerHeight={ paneHeight }
				padding={ 15 }
				headerText='Email+ Service'
				subHeaderText='Premium service by Chated.io'
			>
				<Stepper activeStep={stepIndex} orientation="vertical">
					<Step>
						<StepLabel style={{fontSize: 16}}>Learn about Email+</StepLabel>
						<StepContent>
							<p style={{margin: '12px 0'}}>
								Chated.io's Email+ solution allows you to send abandoned cart emails TWICE more. You will be able to configure the 2nd and 3rd emails separately in any way you want.
							</p>

							<p style={{margin: '12px 0'}}>
								Click the "Next" button below and let's prod your customers to BUY BUY BUY!
							</p>
							<br />
							{this.renderStepActions(0)}
						</StepContent>
					</Step>
					<Step>
						<StepLabel style={{fontSize: 16}}>Select a plan that fits your needs</StepLabel>
						<StepContent>
							{/* <Message
								positive
								color='yellow'
								style={{margin: '12px 12px', fontWeight: 400, maxWidth: '742px'}}
								icon='thumbs up'
								header='Give us a 5-Star review and get 1 MONTH FREE'
								content={<p>Once you have given us a rating, email us at support@chated.io to verify your DNS settings. You do not need to click <b>BUY</b> on any of the plans below.</p>}
							/> */}
							<Card.Group className="center" style={{margin: '14px 0', maxWidth: '768px'}} itemsPerRow={3}>
								<Card raised fluid>
									<Card.Content style={{background: '#FAFAFA'}}>
										<Card.Header style={{fontSize: '18px', color: '#4E4E4E', margin: '15px 0', letterSpacing: '1px', fontWeight: '400'}}>
											3 MONTHS
										</Card.Header>
									</Card.Content>
									<Card.Content extra>
										<Card.Description style={{fontSize: '24px', margin: '40px 0px 50px', fontWeight: '700'}}>
											$6.99 / mo
										</Card.Description>
										<p>Enjoy 3 months Email+ service at $20.97</p>
									</Card.Content>
									<Card.Content extra>
										<Button loading={button3MonthsLoading} style={{margin: '10px 0px'}} basic color='green' onClick={this.onClickPlan.bind(this, '3_months_email_plus')}>BUY NOW</Button>
									</Card.Content>
								</Card>
								<Card raised fluid>
									<Card.Content style={{background: '#FFB613'}}>
										<Card.Header style={{fontSize: '18px', color: '#FFFFFF', margin: '15px 0', letterSpacing: '1px', fontWeight: '400'}}>
											12 MONTHS
										</Card.Header>
									</Card.Content>
									<Card.Content extra>
										<Card.Description style={{fontSize: '24px', margin: '40px 0px 50px', fontWeight: '700'}}>
											$4.99 / mo
										</Card.Description>
										<p>Enjoy 12 months Email+ service at $59.88</p>
									</Card.Content>
									<Card.Content extra>
										<Button loading={button12MonthsLoading} style={{margin: '10px 0px'}} basic color='green' onClick={this.onClickPlan.bind(this, '12_months_email_plus')}>BUY NOW</Button>
									</Card.Content>
								</Card>
								<Card raised fluid>
									<Card.Content style={{background: '#FAFAFA'}}>
										<Card.Header style={{fontSize: '18px', color: '#4E4E4E', margin: '15px 0', letterSpacing: '1px', fontWeight: '400'}}>
											6 MONTHS
										</Card.Header>
									</Card.Content>
									<Card.Content extra>
										<Card.Description style={{fontSize: '24px', margin: '40px 0px 50px', fontWeight: '700'}}>
											$5.99 / mo
										</Card.Description>
										<p>Enjoy 6 months Email+ service at $35.94</p>
									</Card.Content>
									<Card.Content extra>
										<Button loading={button6MonthsLoading} style={{margin: '10px 0px'}} basic color='green' onClick={this.onClickPlan.bind(this, '6_months_email_plus')}>BUY NOW</Button>
									</Card.Content>
								</Card>
							</Card.Group>
							<FlatButton
								label="Back"
								disableTouchRipple={true}
								disableFocusRipple={true}
								onClick={this.handlePrev}
							/>
						</StepContent>
					</Step>
					<Step>
						<StepLabel style={{fontSize: 16}}>FINISH!</StepLabel>
						<StepContent>
							<p style={{margin: '12px 0'}}>
								Congratulations!
							</p>
							<p style={{margin: '12px 0'}}>
								You can now send more abandoned cart emails to your customers! For any problems
								or concerns, please email our support (
								<span style={{color: '#007ec0', fontWeight: 500}}>support@chated.io</span>)
								to assist you.
							</p>
							<p style={{margin: '12px 0'}}>
								Well then, let's start sending emails out!
							</p>
						</StepContent>
					</Step>
				</Stepper>
			</Tab.Pane>
		);
	}
}

export function mapsStateToProps ( state ) {
	return {
		paid: state.callbackPaymentReducer.paid,
		appConnection: state.dashboardEmailsReducer.appConnection,
		paymentPlans: state.emailPlusReducer.paymentPlans,
		confirmationUrl: state.emailPlusReducer.confirmationUrl
	};
}

export function mapsDispatchToProps ( dispatch ) {
	return {
		getShopifyAppConnection () {
			dispatch( getShopifyAppConnection() );
			dispatch( getPaymentPlans() );
		},

		sendPayment (appConnection, chosenPlan, returnUrl) {
			dispatch( sendPayment(appConnection, chosenPlan, returnUrl) );
		}
	};
}

export default connect(mapsStateToProps, mapsDispatchToProps)( Dimensions()(EmailPlusSetupPage) );



// WEBPACK FOOTER //
// ./src/containers/email-plus-page/email-plus-setup-page.js